import React, { Component } from 'react';
import { Button } from 'antd';


export default class ARButton extends Component {
    render() {
        const { className, style, forceElemState, buttonType, width, minWidth, maxWidth,  ...props } = this.props;

        if (props && !props.size) {
            props.size = "large";
        }

        let buttonClasses = ["ar-button"];
        if(className){
            buttonClasses.push(className);
        }
        if (forceElemState) {
            buttonClasses.push(forceElemState + "-demo");
        }
        if(buttonType){
            buttonClasses.push(buttonType);
        }

        let stylesObject = {};
        if(style) stylesObject = style;
        if(width){ stylesObject.width = width; }
        if(minWidth){ stylesObject.minWidth = minWidth; }
        if(maxWidth){ stylesObject.maxWidth = maxWidth; }

        return (
            <Button
                {...props}
                style={stylesObject}
                className={buttonClasses.join(' ')}
            >
                {props.children}
            </Button>
        )
    }
}